import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LeafletService {

    public L: any = null;

    constructor(@Inject(PLATFORM_ID) private platformId: Object) {
        if (isPlatformBrowser(this.platformId)) {
            // 1. Hlaða leaflet
            import('leaflet').then((leaflet) => {
                this.L = leaflet;

                // 2. Setja leaflet á window fyrir markercluster
                (window as any).L = leaflet;

                // 3. Þá má hlaða markercluster sem víkkar út L
                import('leaflet.markercluster').then(() => {
                    // Núna er this.L.MarkerClusterGroup til
                    // console.log('MarkerClusterGroup:', this.L.MarkerClusterGroup);
                }).catch(err => console.error('Villa við markercluster import:', err));
            }).catch(err => console.error('Villa við leaflet import:', err));
        }
    }
}
